export const isClient = () => typeof window !== 'undefined';

export const getEnv = () => {
  if (isClient()) {
    return window.env;
  }
  return process.env;
};

export const safeClientCallback = <T>(
  fn: (...args: any[]) => T,
  serverFallback: T
): ((...args: any[]) => T) => {
  if (isClient()) {
    return fn;
  }
  return () => serverFallback;
};
